import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import instance from "services/axiosServices";

export function useEmpreendimentosValidosSul(props: QueryGlobalInterface) {
  const fetchData = async () => {
    const EMPREEDIMENTOS_VALIDOS = `locais/admin/empreendimentos/v1/empreendimentos-validos`;
    const response = await instance.get(EMPREEDIMENTOS_VALIDOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    // onError: (error: any) => {
    //   toast.error(`Erro ao buscar oportunidades. Tente novamente.`);
    //   console.error(error);
    // },
  });
  return query;
}
